import Api from './Api'

const END_POINT = 'companies'

export default {
    async get_all(filters = null) {        
        let request = {
            params: filters
        }
        return await Api.get(`${END_POINT}`, request)
    },
    async store(company) {
        return await Api.post(`${END_POINT}`, company)
    },
    async update(company) {
        return await Api.patch(`${END_POINT}/${company.id}`, company)
    },
    async change_status(company) {
        return await Api.patch(`${END_POINT}/${company.id}/change-status`, company)
    },
    async delete(company) {
        return await Api.delete(`${END_POINT}/${company.id}`, company)
    }
}